const {RequestBuilder} = KalturaPlayer.providers;

interface AttachmentAssetLoaderParams {
  entryId: string;
  tags: string;
}

class AttachmentAssetLoader implements KalturaPlayerTypes.ILoader {
  private url = null;
  private entryId;
  requests: any[];

  static get id(): string {
    return 'plugin-advanced-audio-description';
  }

  constructor({entryId, tags}: AttachmentAssetLoaderParams) {
    this.entryId = entryId;

    const headers: Map<string, string> = new Map();

    const attachmentAssetRequest = new RequestBuilder(headers);
    attachmentAssetRequest.service = 'attachment_attachmentasset';
    attachmentAssetRequest.action = 'list';
    attachmentAssetRequest.params = {
      filter: {
        objectType: 'KalturaAssetFilter',
        entryIdEqual: entryId,
        tagsLike: tags
      }
    };
    this.requests = [attachmentAssetRequest];

    const getFileUrlRequest = new RequestBuilder(headers);
    getFileUrlRequest.service = 'attachment_attachmentasset';
    getFileUrlRequest.action = 'getUrl';
    getFileUrlRequest.params = {
      id: '{1:result:objects:0:id}'
    };

    this.requests = [attachmentAssetRequest, getFileUrlRequest];
  }

  set response([, response2]: [any, any]) {
    if (response2 && !response2.hasError && response2.data) {
      this.url = response2.data;
    }
  }

  isValid(): boolean {
    return !!this.entryId;
  }
}

export {AttachmentAssetLoader};
